import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import useFontObserver from '../../hooks/useFontObserver';
import Helmet from 'react-helmet';

import CountryChecker from '../../components/CountryChecker';
import Header, { SimpleHeader } from '../../components/Header';
import Footer from '../../components/Footer';
import GlobalStyles from '../../ui/Globals';
import { reduceCountries } from '../../ui/helpers';

import CheckerContext from '../../components/CountryChecker/CheckerContext';
import Main from '../styles';

import contacto from '../../images/Contacto.png';
import OImage from '../../components/OImage';
interface IProps {
  children: any;
  lang: string;
  country: string;
  countryCode: string;
  alternates?: Array<any>;
  translations?: any;
  pageCta?: any;
  checker?: boolean;
  pageHref?: string;
  isFranchise?: boolean;
  bottomImage?: boolean;
}

const Layout = ({
  children,
  lang,
  alternates,
  country,
  countryCode,
  translations,
  pageCta,
  checker = true,
  pageHref,
  isFranchise = false,
  bottomImage = false
}: IProps) => {
  const [context, setContext] = useState<boolean>(false);
  useFontObserver(['CaligraKids', 'DINosaur']);

  const data = useStaticQuery(graphql`
    query DefaultSiteQuery {
      site {
        siteMetadata {
          title
          companyName
          countriesDomain
          cdnUrl
        }
      }
      allCountryCountry {
        nodes {
          id
          status
          title
          field_country_code
          field_domain {
            uri
          }
          relationships {
            field_default_language {
              drupal_id
              drupal_internal__id
              label
            }
            field_languages {
              drupal_id
              drupal_internal__id
              label
            }
          }
        }
      }
    }
  `);

  const {
    site: { siteMetadata }
  } = data;
  const { countries, languages } = reduceCountries(data.allCountryCountry.nodes);

  const breadcrumbs = {
    language: lang,
    country: countryCode,
    pageHref: {
      alias: pageHref,
      domain: countries.find(country => country.langcode === lang)?.domain
    }
  };

  return (
    <>
      <CheckerContext.Provider value={{ context, setContext }}>
        <GlobalStyles />
        <Helmet>
          <link rel="preconnect" href={siteMetadata.cdnUrl} />
          <link rel="dns-prefetch" href={siteMetadata.cdnUrl} />
        </Helmet>
        {checker ? (
          <Header
            siteTitle={siteMetadata?.title || `Title`}
            lang={lang}
            pageCta={pageCta}
            domain={countries.find(country => country.langcode === lang)?.domain}
            country={countries.find(country => country.languages.includes(lang))?.code}
            pageHref={pageHref}
            translations={translations}
            isFranchise={isFranchise}>
            <CountryChecker
              countries={countries}
              country={country}
              countryCode={countryCode}
              countriesDomain={siteMetadata.countriesDomain}
              translations={translations}
            />
          </Header>
        ) : (
          <SimpleHeader></SimpleHeader>
        )}

        <Main>
          {children}
          {bottomImage && (
            <div className="bottomImage">
              <OImage src={contacto} alt="" aspectRatio={4 / 3} aria-hidden="true" />
            </div>
          )}
        </Main>
        <Footer
          companyName={siteMetadata?.companyName || siteMetadata?.title}
          countries={countries}
          languages={languages}
          country={country}
          countryCode={countryCode}
          countriesDomain={siteMetadata.countriesDomain}
          translations={translations}
          lang={lang}
          alternates={alternates}
          breadcrumbs={breadcrumbs}
        />
      </CheckerContext.Provider>
    </>
  );
};

export default Layout;
